'use strict';

angular.module('shiftTraderApp')
  .service('PositioningService', function () {

    var calcLeftAndWidthInRatios = function(objectTwix, viewTwix) {
      var diffInHours, fromLastView, intoNextView, diff, startOffset, viewTwixLengthInHours;
      fromLastView = intoNextView = false;

      diff = objectTwix.length('seconds');
      viewTwixLengthInHours = viewTwix.length('minutes') / 60.0;

      startOffset = moment(viewTwix.start).twix(objectTwix.start).length('minutes') / 60.0;
      // take care of the fact that different timezone offsets based on DST could shift everything over...
      if (viewTwix.start._offset !== objectTwix.start._offset) {
        startOffset = startOffset + (viewTwix.start._offset - objectTwix.start._offset) / 60.0;
      }

      //check if we are overlapping with the next view (shift runs midnight of current day + hourExtensionToRight
      if (diff > objectTwix.start.twix(viewTwix.end).length('seconds')) {
        intoNextView = true;
        diff = objectTwix.start.twix(viewTwix.end).length('seconds');
      } else if (diff > viewTwix.start.twix(objectTwix.end).length('seconds')) {
        fromLastView = true;
        diff = viewTwix.start.twix(objectTwix.end).length('seconds');
        startOffset = 0;
      }

      diffInHours = diff / 3600.0;

      return {
        diffInHours: diffInHours,
        fromLastView: fromLastView,
        intoNextView: intoNextView,
        styles: {
          left: startOffset / viewTwixLengthInHours,
          width: diffInHours / viewTwixLengthInHours
        }
      };
    };

    var calcWorkPeriodShiftRow = function(wpsCollection) {
      // returns numRows and an array of top offsets in the same order as the incoming collection
      // loop over the collection, find the row that the time interval fits onto without touching.
      // if it doesn't then it creates another row
      var numRows = 0;
      var lastTimeByRow = [];
      var result = [];

      _.each(wpsCollection, function(wps) {
        var start, end;
        if (wps.editingTwix) {
          start = wps.editingTwix.start;
          end = wps.editingTwix.end;
        } else {
          start = wps.start_time;
          end = wps.end_time;
        }
        if (numRows === 0) {
          result.push(0);
          numRows = 1;
          lastTimeByRow.push(moment(end));
        } else {
          // this isn't the first shift, so we have a row
          var idx = _.findIndex(lastTimeByRow, function(endTime) {
            return start.isAfter(endTime);//|| wps.start_time.isSame(endTime, 'minute');
          });

          if (idx > -1) {
            // we found a row allows us to put this shift in its row
            result.push(idx);
            lastTimeByRow[idx] = moment(end);
          } else {
            result.push(numRows);
            numRows += 1;
            lastTimeByRow.push(moment(end));
          }
        }
      });

      return {
        rows: result,
        numRows: numRows
      };
    };

    var calcWorkIntervals = function(collection, viewTwix, endpointCalcFn, testFn, styleFn ) {
      var allEndpoints = [];
      var allIntervals = [];
      var intervalIndicesToRemove = [];
      var viewTwixLength = viewTwix.length('minutes');
      var maxCount = 0;
      var prevInterval;
      var lastKnownGoodIdx = 0;

      allEndpoints = endpointCalcFn(collection, viewTwix, viewTwixLength);

      //loop over all of the endpoints and create intervals
      _.each(allEndpoints, function(endpoint, idx) {
        if (idx > 0) {
          allIntervals.push({
            interval: [allEndpoints[idx - 1], endpoint],
            count: 0
          });
        }
      });

      // call the testFn, have testFn create a 'count' property on dikt
      _.each(allIntervals, function(dikt) {
        testFn(dikt, collection, viewTwix);

        if (dikt.count > maxCount) {
          maxCount = dikt.count;
        }
      });

      //if there are intervals next to each other that have the same count, combine them.
      //queue up the removal of the later indice of the two being combined
      _.each(allIntervals, function(dikt, idx) {
        if (idx > 0 && dikt.count === allIntervals[idx - 1].count) {
          prevInterval = allIntervals[lastKnownGoodIdx];
          if (!prevInterval.combinedIntervals) {
            prevInterval.combinedIntervals = [];
          }
          prevInterval.combinedIntervals.push(_.clone(dikt.interval));
          prevInterval.interval[1] = _.clone(dikt.interval[1]);
          intervalIndicesToRemove.push(idx);
        } else {
          lastKnownGoodIdx = idx;
        }
      });

      // remove combined intervals in reverse order so as to preserve the indices added onto the array
      _.each(intervalIndicesToRemove.reverse(), function(idx) {
        allIntervals.splice(idx, 1);
      });

      var widthTemp;
      //loop over all of the intervals and compute styles
      _.each(allIntervals, function(dikt, idx) {
        widthTemp = (dikt.interval[1] - dikt.interval[0]) / viewTwixLength * 100;
        dikt.styling = {
          width: widthTemp + '%',
          left: dikt.interval[0] / viewTwixLength * 100 + '%'
        };

        dikt.showLabel = widthTemp > 2.5;

        if (styleFn) {
          styleFn(dikt, idx, allIntervals[idx - 1], maxCount);
        }
      });

      return allIntervals;
    };

    return {
      calcLeftAndWidthInRatios: calcLeftAndWidthInRatios,
      calcWorkPeriodShiftRow: calcWorkPeriodShiftRow,
      calcWorkIntervals: calcWorkIntervals
    };

  });
